import { render } from "./P004.vue?vue&type=template&id=201c20a4&scoped=true"
import script from "./P004.vue?vue&type=script&lang=js"
export * from "./P004.vue?vue&type=script&lang=js"

import "./P004.vue?vue&type=style&index=0&id=201c20a4&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201c20a4"]])

export default __exports__